import { FC } from 'react';
import { IStudent, IStudentClassInfo } from '../../../models/students.model';
import { Descriptions } from 'antd';
import { useTranslation } from 'react-i18next';

interface IProps {
  student: IStudent|undefined;
  classInfo?: IStudentClassInfo[]|undefined;
}

const StudentName: FC<IProps> = ({
  student,
  classInfo,
}) => {
  const { t } = useTranslation();

  return (
    <div className='comm-table__area rowType'>
      <Descriptions
        bordered
        size="small"
        column={classInfo ? 4 : 2}
        labelStyle={{ width: classInfo ? '10%' : '15%' }}
        contentStyle={{ width: classInfo ? '15%' : '35%' }}
      >
        <Descriptions.Item label={t('student.student.column5') + '(ID)'}>
          {student?.studentKorName}
          ({student?.webId})
        </Descriptions.Item>
        <Descriptions.Item label={t('student.student.column1')}>
          {student?.studentEngName}
        </Descriptions.Item>
        {classInfo && (
          <>
            <Descriptions.Item label={t('common.menu.class')}>
              {classInfo.find(item => item.classStudentStatusCode === 'RE')?.className}
            </Descriptions.Item>
            <Descriptions.Item label={t('student.student.column64')}>
              {student?.studentCode}
            </Descriptions.Item>
          </>
        )}
      </Descriptions>
    </div>
  );
}

export default StudentName;